import { pemValidator } from '#validation/common/validators';
export const ssoCertificateValidator = pemValidator({
    requiredError: 'sso.certificate.required',
    invalidFormatError: 'sso.certificate.format',
    expiredError: 'sso.certificate.expired',
    maxLength: {
        max: 9192,
        error: 'sso.certificate.maxLength',
    },
});
